export const GlobalConstants = {
  API_BASE: '/api/v1',
  API_URL: 'http://3.210.159.100',
  FULL_API_URL: 'http://3.210.159.100/api/v1',

  TOKEN_KEY: 'ks_auth_token',
  REFRESH_KEY: 'ks_refresh_token',
  USER_KEY: 'ks_user',

  USER_ROLES: {
    ADMIN: 'ADMIN',
    FAMILY_LEAD: 'FAMILY_LEAD',
    FAMILY_MEMBER: 'FAMILY_MEMBER',
  },

  PUBLIC_PATHS: [
    '/auth/login',
    '/auth/register',
    '/auth/verify-otp',
    '/auth/resend-otp',
    '/auth/otp-login',
    '/auth/refresh',
    '/auth/password/',
    '/family/invites/accept',
    '/api/v1/health',
  ],

  PAGE_SIZE: 20,

  TOAST: {
    SUCCESS: 'success',
    ERROR: 'error',
  },

  COMPONENT: {
    USERS_LIST: 'ks-users-list',
    ROLES_LIST: 'ks-roles-list',
    SUBSCRIPTIONS_LIST: 'ks-subscriptions-list',
    LOGIN: 'ks-login',
    REGISTER: 'ks-register',
  },
} as const;